export { CustomInput } from './component';
export type { Props } from './types';
